export const SUPPORTED_I18N_LANGUAGES = ['en', 'sv'] as const

export type SupportedI18nLanguage = (typeof SUPPORTED_I18N_LANGUAGES)[number]

export type ContentfulLocale = 'en-US' | 'sv-SE'

export function normalizeI18nLanguage(
  language: string | null | undefined,
): SupportedI18nLanguage {
  const normalized = (language ?? 'en').toLowerCase().split('-')[0]
  return normalized === 'sv' ? 'sv' : 'en'
}

export function getContentfulLocaleForLanguage(
  language: string | null | undefined,
): ContentfulLocale {
  return normalizeI18nLanguage(language) === 'sv' ? 'sv-SE' : 'en-US'
}
